import Vue from "vue";
import Vuex from "vuex";
import uid from "uid";
import _ from "lodash";

Vue.use( Vuex );

export default new Vuex.Store( {
  state: {
    showChildRsSidebar: false,
    accessToken: null,
    dueDiligenceRemediationMonitoringTabLazyLoad: true,
    auditTrailTabLazyLoad: true,
    documentsTabLazyLoad: true,
    questionnairesPoliciesTrainingTTabLazyLoad: true,
    isSidebarStatus: false,
    hola: "holalala",
    isDisabledTranslation: false,
    authToken: null,
    selectedLanguage: "english",
    rightAlign: false,
    getSelectedSectionIndex: undefined,
    getSelectedFieldIndex: undefined,
    isLoading: false,
    isLoadingMulti: false,
    toggleAllCoppalse: true,
    tempForm: {},
    userForm: {},
    selectedAnswersForExams: [],
    userFormSubmitArray: [],
    getUserFormSubmitArray: [],
    validFields: true,
    progressValue: 0,
    progressMaxValue: 0,
    registerData: {},
    pdfForms: [],
    practiceExams: [],
    selectedCompany: null,
    form1: {
      version: 1.0,
      formId: null,
      formStatus: 1, // 1=draft, 2=published, 3=expired
      formDefaultLanguage: "english",
      formVersion: null,
      formTitle: {
        english: "Form Title",
      },
      formDescription: {
        english: "Form Description",
      },
      formIntroText: {
        english: null,
      },
      formType: 1, // 1= Questionaire, 2= Survey, 3=Training, 4= Exam
      formTranslations: ["English"],
      formSection: [
        {
          type: "section",
          id: uid(),
          index: 0,
          name: "",
          isRepeatable: false,
          sectionTitle: {
            english: "Section 1 Title",
          },
          formElements: [],
        },
      ],
      formJSCode: null,
      formCSS: null,
      formLayout: "vertical", // 'tabs',
      formPassword: null,
    },

    // Configurable PRI
    isLoadingPriData: false,
    allPriItems: [],
    clientAllPriItems: [],
    clientAllPriOptions: [],
    priConfigrationforms: {
      negativeMedia: {
        scoring: {
          weighting: {
            lowerUpperLimit: 30,
            mediumUpperLimit: 32,
            ageOfArticleWeightingValue: null,
            siteTypeWeightingValue: null,
            nlpMatchWeightingValue: null,
            keywordCountTotalWeightingValue: null,
          },
          ageOfArticleObject: {
            ageOfArticle: true,
            ageOfArticleToValue: [],
            ageOfArticleScoreValue: [],
          },
          siteTypeObject: {
            siteType: true,
            localSiteType: null,
            regionalSiteType: null,
            globalSiteType: null,
            unkownSiteType: null,
          },
          keywordCountObject: {
            keywordCountTotal: true,
            lowerUpperLimit: 30,
            mediumUpperLimit: 32,
          },
          nlpMatchObject: {
            nlpMatch: true,
            matchNlpValue: null,
          },
        },
        categories: [],
      },
      futureRisks: {
        scoring: {
          weighting: {
            lowerUpperLimit: 30,
            mediumUpperLimit: 32,
            ageOfArticleWeightingValue: null,
            siteTypeWeightingValue: null,
            nlpMatchWeightingValue: null,
            keywordCountTotalWeightingValue: null,
          },
          ageOfArticleObject: {
            ageOfArticle: true,
            ageOfArticleToValue: [],
            ageOfArticleScoreValue: [],
          },
          siteTypeObject: {
            siteType: true,
            localSiteType: null,
            regionalSiteType: null,
            globalSiteType: null,
            unkownSiteType: null,
          },
          keywordCountObject: {
            keywordCountTotal: true,
            lowerUpperLimit: 30,
            mediumUpperLimit: 32,
          },
          nlpMatchObject: {
            nlpMatch: true,
            matchNlpValue: null,
          },
        },
        categories: [],
      },
      sanctions: {
        isIDD: false,
        isIddPlus: false,
        indicatorIsHigh: false,
        indicatorIsOverallHigh: false,
        eventCategoryCodeSelected: null,
        eventSubCategoryCodeSelected: null,
        lowerUpperLimit: 30,
        mediumUpperLimit: 32,
        setMatchScores: null,
        CVIP: false,
        riskScore: false,
        textMatch: false,
        pepMatch: false,
        entityMatch: false,
        identifierMatch: false,
        CVIPCategoryValue: [],
        CVIPScoreValue: [],
        riskScoreCategoryValue: [2],
        riskScoreScoreValue: [],
        pepMatchInput: null,
        processScoreCategoryValue: [2],
        processScoreValue: [],
        similarTextCategoryScoreValue: [2],
        similarTextScoreValue: [],
        tokenSortCategoryScoreValue: [2],
        tokenSortScoreValue: [],
        tokenSortRatioCategoryScoreValue: [2],
        tokenSortRatioScoreValue: [],
        soundEx: null,
        identifiersItems: [],
        validInputField: false,
      },
      countryRules: {
        cpiIndex: false,
        activeSanctions: false,
        activeSanctionsScoring: null,
        lowerUpperLimit: 30,
        mediumUpperLimit: 32,
      },
      overallWeighting: {
        defaultIndicators: [],
        customIndicators: [],
        lowerUpperLimit: 30,
        mediumUpperLimit: 75,
      },
      customIndicationsSettings: {
        customIndicatorsTabs: [],
      },
      openCorporate: {
        companyNumber: false,
        partialSearch: false,
        globalSearch: false,
        stopWords: false,
        stopWordsList: [],
        veryRare: null,
        rare: null,
        common: null,
        veryCommon: null,
        disableRemovalText: false,
      },
      publicListings: {
        matchExact: false,
        matchPartial: false,
        matchSimilar: false,
        stopWords: false,
        stopWordsList: [],
        disableRemovalText: false,
      },
    },

    // --------------------- store for Remediation ----------------------------------------
    totalAlerts: 0,
    totalPendingAlerts: 0,
    totalRemidiatedAlerts: 0,
    totalPositiveAlerts: 0,
    totalNegativeAlerts: 0,
    secUniqueCount: 0,
    tabIndex: 1,
    reviewTab: true,
    associateTab: true,
    resultTab: true,

    // Employees Variable
    sidebarv2Collapse: false,
    approvalsLazyLoad: true,
    employeesLazyLoad: true,
    complaintsLazyLoad: true,
    approvalModalCategories: [],
    complaintSettingsWorkFlowCategories: [],
    settingSelectedLanguage: [{ text: "English", value: "1" }],
    profileImageBaseContent: null,
    employeeDashboardTabIndex: 0,
    employeeDashboardActionsLazyLoad: true,
    employeeDashboardGiftsLazyLoad: true,
    employeeDashboardComplaintsLazyLoad: true,
    activeEmployeeTabLazyLoad: true,
    terminatedEmployeeTabLazyLoad: true,
    showSidebar: false,
    policyFormsTasks: [],
    trainingFormsTasks: [],
    certificationFormsTasks: [],
    selectedTaskType: localStorage.getItem("selected_task_type"),
  },

  getters: {
    form1: ( state ) => {
      return state.form1;
    },

    selectedAnswersForExams: ( state ) => {
      return state.selectedAnswersForExams;
    },

    validFields: ( state ) => {
      return state.validFields;
    },

    progressValue: ( state ) => {
      return state.progressValue;
    },

    progressMaxValue: ( state ) => {
      return state.progressMaxValue;
    },
    registerData: ( state ) => {
      return state.registerData;
    },

    userFormSubmitArray: ( state ) => {
      return state.userFormSubmitArray;
    },
    getUserFormSubmitArray: ( state ) => {
      return state.getUserFormSubmitArray;
    },

    toggleAllCoppalse: ( state ) => {
      return state.toggleAllCoppalse;
    },

    selectedLanguage: ( state ) => {
      return state.selectedLanguage;
    },
    isLoading: ( state ) => {
      return state.isLoading;
    },

    isLoadingMulti: ( state ) => {
      return state.isLoadingMulti;
    },

    getSelectedSectionIndex: ( state ) => {
      return state.getSelectedSectionIndex;
    },
    getSelectedFieldIndex: ( state ) => {
      return state.getSelectedFieldIndex;
    },
    userForm: ( state ) => {
      return state.userForm;
    },
    isLoadingPriData: ( state ) => {
      return state.isLoadingPriData;
    },
    allPriItems: ( state ) => {
      return state.allPriItems;
    },
    clientAllPriItems: ( state ) => {
      return state.clientAllPriItems;
    },
    clientAllPriOptions: ( state ) => {
      return state.clientAllPriOptions;
    },
    priConfigrationforms: ( state ) => {
      return state.priConfigrationforms;
    },
    settingSelectedLanguage: ( state ) => {
      return state.settingSelectedLanguage;
    },
    approvalModalCategories: ( state ) => {
      return state.approvalModalCategories;
    },
    complaintSettingsWorkFlowCategories: ( state ) => {
      return state.complaintSettingsWorkFlowCategories;
    },
    sidebarv2Collapse: ( state ) => {
      return state.sidebarv2Collapse;
    },
    approvalsLazyLoad: ( state ) => {
      return state.approvalsLazyLoad;
    },
    employeesLazyLoad: ( state ) => {
      return state.employeesLazyLoad;
    },
    complaintsLazyLoad: ( state ) => {
      return state.complaintsLazyLoad;
    },
    accessToken: ( state ) => {
      return state.accessToken;
    },
    profileImageBaseContent: ( state ) => {
      return state.profileImageBaseContent;
    },
    employeeDashboardTabIndex: ( state ) => {
      return state.employeeDashboardTabIndex;
    },
    employeeDashboardActionsLazyLoad: ( state ) => {
      return state.employeeDashboardActionsLazyLoad;
    },
    employeeDashboardGiftsLazyLoad: ( state ) => {
      return state.employeeDashboardGiftsLazyLoad;
    },
    employeeDashboardComplaintsLazyLoad: ( state ) => {
      return state.employeeDashboardComplaintsLazyLoad;
    },
    activeEmployeeTabLazyLoad: ( state ) => {
      return state.activeEmployeeTabLazyLoad;
    },
    terminatedEmployeeTabLazyLoad: ( state ) => {
      return state.terminatedEmployeeTabLazyLoad;
    },
    showSidebar: ( state ) => {
      return state.showSidebar;
    },
    tabIndex: ( state ) => {
      return state.tabIndex;
    },
    reviewTab: ( state ) => {
      return state.reviewTab;
    },
    associateTab: ( state ) => {
      return state.associateTab;
    },
    resultTab: ( state ) => {
      return state.resultTab;
    },
    policyFormsTasks: ( state ) => {
      return state.policyFormsTasks;
    },
    trainingFormsTasks: ( state ) => {
      return state.trainingFormsTasks;
    },
    certificationFormsTasks: ( state ) => {
      return state.certificationFormsTasks;
    },
    showChildRsSidebar: ( state ) => {
      return state.showChildRsSidebar;
    },
  },

  mutations: {
    //set the access token
    SET_ACCESS_TOKEN: ( state, accessToken ) => {
      state.accessToken = accessToken;
    },
    TOGGLE_LOADER: ( state, duration ) => {
      state.isLoading = true;
      setTimeout( () => {
        state.isLoading = false;
      }, duration );
    },

    TOGGLE_ALL_COLLAPSE: ( state, value ) => {
      state.toggleAllCoppalse = !state.toggleAllCoppalse;
    },

    // field actiions
    ADD_FIELD: ( state, payload ) => {
      let index = payload.sectionIndex;
      state.form1.formSection[index].formElements.push( payload );
    },

    ADD_TEMP_FORM: ( state, payload ) => {
      state.tempForm = payload;
    },

    CLONE_FIELD: ( state, payload ) => {
      let index = payload.sectionIndex;
      let id = uid();
      let newField;
      newField = {
        ...payload.field,
        id,
      };
      state.form1.formSection[index].formElements.push( newField );
    },

    REMOVE_FIELD: ( state, payload ) => {
      let sectionIndex = payload.sectionIndex;
      let fieldIndex = payload.fieldIndex;
      state.form1.formSection[sectionIndex].formElements.splice( fieldIndex, 1 );
    },

    UPDATE_FORM: (state, payload) => {
      // console.log("payload in stpte", zvx)
      return (state.form1 = payload);
      // state.tempForm = payload
    },

    // section actions
    ADD_SECTION: ( state, payload ) => {
      state.form1.formSection.push( payload );
    },

    CLONE_SECTION: ( state, payload ) => {
      let section = _.cloneDeep( payload );
      let lang = state.selectedLanguage;
      section.sectionTitle[lang] = section.sectionTitle[lang] + " copy";
      let index = state.form1.formSection.length,
        id = uid(),
        newSection;
      newSection = {
        ...section,
        id,
        index,
      };
      newSection.formElements.map( ( el ) => {
        return ( el.id = uid() );
      } );
      state.form1.formSection.push( newSection );
    },

    REMOVE_SECTION: ( state, sectionIndex ) => {
      state.form1.formSection.splice( sectionIndex, 1 );
      state.form1.formSection.map( ( section ) => {
        if ( section.index > sectionIndex ) {
          return ( section.index = section.index - 1 );
        }
      } );
    },

    //not in use
    ADD_SECTON_FIELD: ( state, payload ) => {
      state.form1.formSection[0].formElements.push( payload );
    },

    // language action
    SET_LANGUAGE: ( state, payload ) => {
      state.selectedLanguage = payload;
    },

    CLONE_SECTION_CONTENT: ( state, payload ) => {
      let _id = uid();
      let newField;
      newField = {
        ...payload.field,
        _id,
      };
      state.form1.formSection[payload.index].fields.push( newField );
    },

    // action for address form
    CLONE_ADDRESS_FIELD: ( state, payload ) => {
      let sectionIndex = payload.index;
      let elementIndex = payload.index2;
      let _id = uid();
      let newField;
      newField = {
        ...payload.field,
        _id,
      };
      state.form1.formSection[sectionIndex].formElements[
        elementIndex
      ].fields.push( newField );
    },

    REMOVE_ADDRESS_FIELD: ( state, payload ) => {
      let sectionIndex = payload.index;
      let elementIndex = payload.index2;
      let fieldIndex = payload.index3;
      // state.form1.formSection[sectionIndex].formElements[elementIndex].fields.push(newField)

      state.form1.formSection[sectionIndex].formElements[
        elementIndex
      ].fields.splice( fieldIndex, 1 );
    },

    // index action
    SET_SECTION_INDEX: ( state, payload ) => {
      state.getSelectedSectionIndex = payload;
    },
    SET_FIELD_INDEX: ( state, payload ) => {
      state.getSelectedFieldIndex = payload;
    },
    UPDATE_FORM_JS_CODE: ( state, payload ) => {
      state.form1.formJSCode = payload;
    },
    UPDATE_FORM_CSS: ( state, payload ) => {
      state.form1.formCSS = payload;
    },
    SET_FIELD_VALIDATION: ( state, payload ) => {
      state.form1.formSection[payload.sectionIndex].formElements[
        payload.sectionFieldIndex
      ].validation = payload;
    },
  },

  actions: {
    // for fields
    removeField: ( constext, fieldId ) => {
      constext.commit( "REMOVE_FIELD", fieldId );
    },
    cloneField: ( constext, payload ) => {
      constext.commit( "CLONE_FIELD", payload );
    },

    // for sections
    removeSection: ( constext, fieldId ) => {
      constext.commit( "REMOVE_SECTION", fieldId );
    },
    cloneSection: ( constext, payload ) => {
      constext.commit( "CLONE_SECTION", payload );
    },

    // for language
    setLanguage: ( constext, payload ) => {
      constext.commit( "SET_LANGUAGE", payload );
    },
    repeatSectionContentStore: ( constext, payload ) => {
      constext.commit( "CLONE_SECTION_CONTENT", payload );
    },
    // address form
    cloneAddressField: ( constext, payload ) => {
      constext.commit( "CLONE_ADDRESS_FIELD", payload );
    },
    removeAddressField: ( constext, payload ) => {
      constext.commit( "REMOVE_ADDRESS_FIELD", payload );
    },

    // to get index
    setSectionIndex: ( constext, payload ) => {
      constext.commit( "SET_SECTION_INDEX", payload );
    },
    setfieldIndex: ( constext, payload ) => {
      constext.commit( "SET_FIELD_INDEX", payload );
    },
    updateField: ( constext, payload ) => {
      constext.commit( "UPDATE_FIELD", payload );
    },
    updateFormJSCode: ( constext, payload ) => {
      constext.commit( "UPDATE_FORM_JS_CODE", payload );
    },
    updateFormCSS: ( constext, payload ) => {
      constext.commit( "UPDATE_FORM_CSS", payload );
    },
    setFieldValidation: ( constext, payload ) => {
      constext.commit( "SET_FIELD_VALIDATION", payload );
    },
  },

  module: {},
} );
